import { AnnouncementService } from './announcementService';
import { AxiosResponse } from 'axios';
import { DeleteBlobEntity, UpdateAnnouncementDto, DynamicAnnouncementDto, AnnouncementDto } from '../../types/announcement';

export interface ApiAnnouncementService {
    getAnnouncements(urlParams: string): Promise<AxiosResponse>;
    getDynamicAnnouncements(urlParams: string): Promise<AxiosResponse>
    getMaxNumberOfAnnouncements(): Promise<AxiosResponse>;
    getAnnouncementById(announcementId: string): Promise<AxiosResponse>;
    getDynamicAnnouncementById(announcementId: string): Promise<AxiosResponse>
    getAnnouncementsByType(urlParams: string, hasText?: boolean, includeUntyped?: boolean): Promise<AxiosResponse>;

    createAnnouncement(announcement: UpdateAnnouncementDto): Promise<AxiosResponse>;
    createDynamicAnnouncement(announcement: DynamicAnnouncementDto): Promise<AxiosResponse>;
    deleteAnnouncements(data: AnnouncementDto[]): Promise<AxiosResponse>;
    uploadToStorage(data: FormData): Promise<AxiosResponse>;
    deleteFromStorage(blob: DeleteBlobEntity): Promise<AxiosResponse>;
    getAllForTenant(tenantId: string): Promise<AxiosResponse>;
}

export const announcementService = new AnnouncementService();